import type * as Types from 'app/types/graphql';

import {
  ThemePageSelectFragmentDoc,
  ThemePageMetaSelectFragmentDoc,
  ThemePageParentSelectFragmentDoc,
} from '../fragments/themePage.generated';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ThemePageDuplicateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  themeID: Types.Scalars['ID']['input'];
  type?: Types.InputMaybe<Types.ThemePageType>;
}>;

export type ThemePageDuplicateMutationResponse = {
  themePageDuplicate?: Types.Maybe<
    Pick<
      Types.ThemePage,
      | 'id'
      | 'name'
      | 'type'
      | 'default'
      | 'isGlobal'
      | 'status'
      | 'updatedAt'
      | 'publishedAt'
      | 'handle'
    > & {
      metafields?: Types.Maybe<
        Array<
          Types.Maybe<Pick<Types.ThemePageMeta, 'createdAt' | 'id' | 'key' | 'updatedAt' | 'value'>>
        >
      >;
      parent?: Types.Maybe<Pick<Types.ThemePage, 'id' | 'name' | 'type' | 'status' | 'default'>>;
    }
  >;
};

export const ThemePageDuplicateDocument = `
    mutation ThemePageDuplicate($id: ID!, $name: String, $themeID: ID!, $type: ThemePageType) {
  themePageDuplicate(id: $id, name: $name, themeID: $themeID, type: $type) {
    ...ThemePageSelect
  }
}
    ${ThemePageSelectFragmentDoc}
${ThemePageMetaSelectFragmentDoc}
${ThemePageParentSelectFragmentDoc}`;

export const useThemePageDuplicateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ThemePageDuplicateMutationResponse,
    TError,
    ThemePageDuplicateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ThemePageDuplicateMutationResponse,
    TError,
    ThemePageDuplicateMutationVariables,
    TContext
  >(
    ['ThemePageDuplicate'],
    (variables?: ThemePageDuplicateMutationVariables) =>
      appFetcher<ThemePageDuplicateMutationResponse, ThemePageDuplicateMutationVariables>(
        ThemePageDuplicateDocument,
        variables,
      )(),
    options,
  );
};

useThemePageDuplicateMutation.getKey = () => ['ThemePageDuplicate'];
